<div class="modalForm" [formGroup]="form">
  <div class="flex flex-column gap-2 w-full">
    <label for="isEnabled" class="font-semibold">
      {{ "gate_administration.open_times_form.is_enabled" | translate }}</label
    >
    <p-select id="isEnabled" class="w-full" formControlName="isEnabled" [options]="isEnabledOptions" appendTo="body">
      <ng-template let-option pTemplate="selectedItem">
        {{ option.label | translate }}
      </ng-template>
      <ng-template let-option pTemplate="item">
        {{ option.label | translate }}
      </ng-template>
    </p-select>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="alarmBufferMinutes" class="font-semibold">
      {{ "gate_administration.open_times_form.alarm_buffer_minutes" | translate }}*</label
    >
    <p-inputNumber formControlName="alarmBufferMinutes" class="w-full" id="alarmBufferMinutes" />
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="escalationIntervalMinutes" class="font-semibold">
      {{ "gate_administration.open_times_form.escalation_interval_minutes" | translate }}</label
    >
    <p-inputNumber formControlName="escalationIntervalMinutes" class="w-full" id="escalationIntervalMinutes" />
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="pushNotificationEnabled" class="font-semibold">
      {{ "gate_administration.open_times_form.push_notification_enabled" | translate }}</label
    >

    <p-select
      id="pushNotificationEnabled"
      class="w-full"
      [options]="isEnabledOptions"
      formControlName="pushNotificationEnabled"
      appendTo="body"
    >
      <ng-template let-option pTemplate="selectedItem">
        {{ option.label | translate }}
      </ng-template>
      <ng-template let-option pTemplate="item">
        {{ option.label | translate }}
      </ng-template>
    </p-select>
  </div>
  <div class="flex flex-column gap-2 w-full">
    <label for="pushNotificationEnabled" class="font-semibold">
      {{ "gate_administration.open_times_form.timezone" | translate }}</label
    >

    <p-select
      id="timezone"
      class="w-full"
      [filter]="true"
      filterMatchMode="contains"
      [options]="timezoneOptions"
      formControlName="timezone"
      appendTo="body"
    >
      <ng-template let-option pTemplate="selectedItem">
        {{ option.label }}
      </ng-template>
      <ng-template let-option pTemplate="item">
        {{ option.label }}
      </ng-template>
    </p-select>
  </div>
</div>

<div class="flex flex-column gap-2 w-full mb-6" [formGroup]="form">
  <span class="font-semibold mb-4">{{ "gate_administration.open_times_form.open_times" | translate }}</span>
  <div class="openTimesContainer" formGroupName="dayTimewindows">
    @for (day of days; let index = $index; track day.key) {
      <div
        class="flex flex-column gap-3 mb-3 ml-2"
        [formArrayName]="day.key"
        style="min-height: 5rem; box-sizing: content-box"
      >
        <div class="flex gap-3 align-items-center">
          <span> {{ day.label | translate }} </span>
          <app-svg-icon
            iconName="plus"
            iconColor="primary"
            (click)="addTimeWindow(day.key)"
            class="pointer"
          ></app-svg-icon>
        </div>

        @if (getDayFormArray(day.key).length === 0) {
          <span class="font-italic">
            {{ "gate_administration.open_times_form.no_open_times" | translate }}
          </span>
        } @else {
          @for (timeWindow of getDayFormArray(day.key).controls; let index = $index; track index) {
            <div class="flex gap-3 align-items-center">
              <div class="flex gap-3" [formGroupName]="index">
                <div class="flex align-items-center gap-2">
                  <span>{{ "common.from" | translate }}</span>
                  <p-datepicker
                    [style]="{ width: '145px' }"
                    [inputStyle]="{ minWidth: 0 }"
                    formControlName="startTime"
                    [timeOnly]="true"
                    appendTo="body"
                  ></p-datepicker>
                </div>
                <div class="flex align-items-center gap-2">
                  <span>{{ "common.to" | translate }}</span>
                  <p-datepicker
                    [style]="{ width: '145px' }"
                    [inputStyle]="{ minWidth: 0 }"
                    formControlName="endTime"
                    [timeOnly]="true"
                    appendTo="body"
                  ></p-datepicker>
                </div>
              </div>
              <app-svg-icon
                iconName="trash"
                iconColor="primary"
                (click)="deleteTimeWindow(day.key, index)"
                class="pointer"
              ></app-svg-icon>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
<div class="flex gap-2 flex-column mb-6" [formGroup]="form">
  <div class="flex gap-3 align-items-center mb-4">
    <span class="font-semibold">{{ "gate_administration.open_times_form.contacts" | translate }}</span>
    <app-svg-icon iconName="plus" iconColor="primary" class="pointer" (click)="addContact()"></app-svg-icon>
  </div>
  <div formArrayName="contacts" class="flex flex-column gap-3">
    @for (contact of getContactsArray().controls; let index = $index; track index) {
      <div class="flex gap-4 align-items-end ml-2" [formGroupName]="index">
        <div class="flex flex-column gap-2 w-2">
          <span>{{ "gate_administration.open_times_form.email" | translate }}</span>
          <input pInputText formControlName="email" />
        </div>
        <div class="flex flex-column gap-2 w-2">
          <span>{{ "gate_administration.open_times_form.first_name" | translate }}</span>
          <input pInputText formControlName="firstName" />
        </div>
        <div class="flex flex-column gap-2 w-2">
          <span>{{ "gate_administration.open_times_form.last_name" | translate }}</span>
          <input pInputText formControlName="lastName" />
        </div>
        <div class="flex flex-column gap-2 w-2">
          <span>{{ "gate_administration.open_times_form.contact_type" | translate }}</span>
          <p-select [options]="contactTypeOptions" formControlName="type" class="w-full" appendTo="body">
            <ng-template let-option pTemplate="selectedItem">
              {{ option.label | translate }}
            </ng-template>
            <ng-template let-option pTemplate="item">
              {{ option.label | translate }}
            </ng-template>
          </p-select>
        </div>
        <div class="flex flex-column gap-2 w-1">
          <span>{{ "gate_administration.open_times_form.contact_level" | translate }}</span>
          <p-input-number formControlName="level" [inputStyle]="{ minWidth: 0, flexShrink: 1 }" />
        </div>
        <div class="flex flex-column gap-2 w-2">
          <span>{{ "common.language" | translate }}</span>
          <p-select [options]="contactLangOptions" formControlName="lang" class="w-full" appendTo="body">
            <ng-template let-option pTemplate="selectedItem">
              {{ option.label | translate }}
            </ng-template>
            <ng-template let-option pTemplate="item">
              {{ option.label | translate }}
            </ng-template>
          </p-select>
        </div>
        <app-svg-icon
          iconName="trash"
          [iconColor]="index === 0 ? 'secondary' : 'primary'"
          [class]="index === 0 ? 'disabled' : 'pointer'"
          (click)="index !== 0 && deleteContact(index)"
        ></app-svg-icon>
      </div>
    }
  </div>
</div>

<div class="flex flex-column gap-4">
  <span class="font-semibold">{{ "gate_administration.open_times_form.gates" | translate }} </span>
  @if (gates().length > 0) {
    <div class="flex flex-column gap-3 ml-2">
      @for (gate of gates(); track gate.id) {
        <div class="flex align-items-center gap-4">
          <span class="w-8rem text-overflow-ellipsis overflow-hidden white-space-nowrap">{{ gate.label }}</span>
          <app-button
            (click)="toggleSecurity(gate.id, !gate.secure)"
            [buttonText]="
              (gate.secure
                ? 'gate_administration.open_times_form.deactivate_security'
                : 'gate_administration.open_times_form.activate_security'
              ) | translate
            "
          >
          </app-button>
          @if (gate.secure) {
            <app-svg-icon
              iconSize="sm"
              [iconName]="'secure'"
              [iconColor]="'primary'"
              style="stroke-width: 2"
            ></app-svg-icon>
          } @else {
            <app-svg-icon
              iconSize="sm"
              [iconName]="'not_secure'"
              [iconColor]="'critical'"
              style="stroke-width: 2"
            ></app-svg-icon>
          }
        </div>
      }
    </div>
  } @else {
    <span>{{ "gate_administration.open_times_form.no_gates" | translate }}</span>
  }
</div>

<div class="flex justify-content-end gap-2 dialogBtnGroup">
  <app-button id="cancelBuildingButton" buttonText="common.cancel" (click)="closeDialog()"></app-button>
  <app-button buttonText="common.save" (click)="save()" [disabled]="!form.valid"></app-button>
</div>
